import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";

const Box = (props, ref) => {
    const { title, hide = true } = props;
    const [Show, SetShow] = useState(true);

    const HandleShow = () => {
        if(hide) {
            SetShow(!Show)
        }
    }
    return (
        <div className={"mypage-item"}>
            <div className={`inner ${Show}`}>
                <h5 className={`title ${hide}`} onClick={HandleShow}>
                    {props.title} {hide && <FontAwesomeIcon icon={faAngleUp} /> }
                </h5>
                <div className={`content`}>{props.children}</div>
            </div>
        </div>
    );
};

export default Box;
